<template>
<v-card>
  <request-status :request="req" @ok="$emit('saved', payload)" />
  <v-card-title class='subtitle-1 overline' >
    Add an existing colleague to a space that you own
    <v-spacer />
    <v-btn icon small @click="$emit('close')" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-subheader class="overline" >Choose a space</v-subheader>
    <space-picker chips owner-required return-object v-model="space" />
    <template v-if="space && space.id" >
      <v-subheader class="overline" >Choose a colleague</v-subheader>
      <v-list dense >
        <v-list-item-group v-model="colleague" color="primary" >
          <template v-for="p in addable" >
            <v-list-item rounded :key="p.id" :value="p" >
              <v-list-item-content>
                <v-list-item-title v-text="p.full_name" >
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-avatar v-if="p.profile_picture" >
                <v-img :src="p.profile_picture" />
              </v-list-item-avatar>
            </v-list-item>
            <v-divider :key="`div-${p.id}`" />
          </template>
        </v-list-item-group>
      </v-list>
    </template>

    <v-card outlined rounded
      v-if="space && space.id && colleague && colleague.id"
      class="mt-3" >
      <v-card-title class='subtitle-1 overline' >
        Please confirm:
      </v-card-title>
      <v-card-text>
        Add {{colleague.full_name}} as a member to {{space.title}}
      </v-card-text>
      <v-card-actions >
        <v-spacer/>
        <v-btn color="primary" @click="save" :loading="req.loading" >Add {{colleague.full_name}} </v-btn>
      </v-card-actions>
    </v-card>

    <!-- <pre v-text="payload" /> -->
    <!-- <pre v-text="spacesIOwn" /> -->
  </v-card-text>
</v-card>
</template>
<script>
import { mapGetters } from "vuex"
import SpacePicker from "@/components/pickers/SpacePicker.vue"

export default {
  name: 'AddColleague',
  components: { SpacePicker },
  data () {
    return {
      space: {},
      colleague: {},
      role: 'Member',
      req: {
        resource: 'ag.team',
        extra: 'add_member_to_space',
        method: 'post'
      }
    }
  },
  methods: {
    save () {
      this.req.data = this.payload
      this.$request('save', this.req)
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) {
        this.$emit('saved', this.req)
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['practitionersList']),
    requestStatus () {
      return this.getObjectPath(this.req, 'status', 0)
    },
    addable () {
      let ps = this.practitionersList
      if (this.space && this.space.members && this.space.members.length > 0) {
        let addable = []
        ps.forEach(p => {
          if (this.space.members.indexOf(p.id) === -1) {
            addable.push(p)
          }
        })
        return addable
      } else {
        return ps
      }
    },
    payload () {
      return {
        practitioner: this.colleague.id,
        space: this.space.id,
        role: this.role
      }
    }
  }
}
</script>
